<template>
  <div class="vz-layout vz-layout-player">
    <nuxt />
    <vz-dialog
      :active="dialog.active"
      :title="dialog.title"
      :type="dialog.type"
      :buttons="dialog.buttons"
    >
      {{ dialog.text }}
    </vz-dialog>
  </div>
</template>

<script>
import VzDialog from 'vsp-web-ui-lib/components/organisms/vz-dialog.vue';
import Base from './_base.vue';

export default {
  name: 'PlayerLayout',
  extends: Base,
  components: {
    VzDialog
  },
  middleware: ['mobile-app-check', 'auth'],

  computed: {
    dialog() {
      return this.$store.state.ui.dialog;
    }
  }
};
</script>

<style>
@import '~theme/style.css';
@import '~client/style.css';
</style>

<style theme="dark-theater" scoped>
.vz-layout-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
}
</style>










